import utils from "../../../utils/utils";
export default {
    async addAppStoreAccount(_, payload) {
        await utils.utility.fetch("api/Setting/AddAppStoreAccount", "POST", null, payload);
    },
    async fetchConnectedAccounts(context, payload) {
        const response = await utils.utility.fetch(`api/Setting/GetSocialMediaAccounts?source=${payload.source}&accountType=${payload.accountType}&pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}&sortDirection=${payload.sortDirection}&searchText=${payload.searchText}`);                
        context.commit("setConnectedAccounts", response.data);
    },
    async fetchClientDetails(context, payload) {
        const response = await utils.utility.fetch(`api/Setting/GetAppStoreDefinition?clientId=${payload.accountId}&clientSecKey=${payload.accountSecret}`,"GET",null,null)        
        context.commit("setClientDetails", response.data);
    },
    async deleteAccount(_,payload){
        await utils.utility.fetch("api/Setting/DeleteSocialMediaAccount","PUT",null, payload);        
    },
    async addPackage(_,payload){
        await utils.utility.fetch("api/Setting/AddAppStoreApp","POST",null, payload);  
    },
    async deletePackage(_,payload){
        await utils.utility.fetch("api/Setting/DeleteStoreApp","PUT",null,payload);
    },
    async getPackages(context,payload){
        const response = await utils.utility.fetch(`api/Setting/GetStoreApps?accountId=${payload}`,"GET",null,null);
        context.commit("setPackages",response.data);

    }
}
